/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const eventScan = `mutation EventScan($customer_id: String!, $event_id: String!) {
    eventScan(customer_id: $customer_id, event_id: $event_id) { id }
  }
  `;
